import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import { sendEvent } from 'lib/gtag';

const Dropdown = dynamic(() => import('./Dropdown'), { ssr: false });

const Context = ({
  gaEventCategory,
  offerCoupon,
  offerId,
  offerInstructions,
  offerPrice,
  offerPriceType,
  offerStatusName,
  userId,
}) => {
  const openerRef = useRef(null);
  const [isOpen, setOpen] = useState(false);

  const onToggleDropdown = () => {
    setOpen((prevState) => !prevState);

    sendEvent({
      action: 'report_offer',
      category: gaEventCategory,
    });
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <div className="relative h-fit">
      <Button
        ref={openerRef}
        arial-label="Mais ações"
        className="[&>svg]:text-rd-primary-700 dark:[&>svg]:text-rd-primary-700"
        icon={<Icon name="more-vert" />}
        size="size3"
        type="primary-ghost"
        onClick={onToggleDropdown}
      />
      {isOpen && (
        <Dropdown
          gaEventCategory={gaEventCategory}
          offerCoupon={offerCoupon}
          offerId={offerId}
          offerInstructions={offerInstructions}
          offerPrice={offerPrice}
          offerPriceType={offerPriceType}
          offerStatusName={offerStatusName}
          openerRef={openerRef}
          userId={userId}
          onClose={onClose}
        />
      )}
    </div>
  );
};

Context.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  offerCoupon: PropTypes.string.isRequired,
  offerId: PropTypes.number.isRequired,
  offerInstructions: PropTypes.string.isRequired,
  offerPrice: PropTypes.number.isRequired,
  offerPriceType: PropTypes.string.isRequired,
  offerStatusName: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
};

export default Context;
